import { AssetClass } from '@src/enums'
import { Asset } from '@src/types'

const allClasses = Object.values(AssetClass)

const toggles: { id: keyof Asset; appliedTo: AssetClass[] }[] = [
    { id: 'is_tied_agent', appliedTo: allClasses },
    { id: 'transferable', appliedTo: allClasses },
    {
        id: 'is_subordinated',
        appliedTo: [AssetClass.SUBORDINATED_LOAN, AssetClass.BOND],
    },
    {
        id: 'cooperative_additional_contribution',
        appliedTo: [AssetClass.COOPERATIVE_SHARE],
    },
    {
        id: 'spv_participation_exemption',
        appliedTo: [AssetClass.PROFIT_PARTICIPATION_SPV],
    },
]

/**
 * Makes sure no asset-class toggle is null/undefined: the API expects a boolean.
 * Toggles that don't belong to the selected class are set to null, because the
 * API prohibits them for any other class. Without a class selected, nothing is
 * prohibited, so every toggle defaults to false.
 */
export function normalizeAssetClassToggles(asset: Asset) {
    toggles.forEach(({ id, appliedTo }) => {
        const value = asset[id]
        const belongsToClass =
            !asset.asset_class || appliedTo.includes(asset.asset_class)
        if (belongsToClass) {
            if (value === null || value === undefined) {
                ;(asset as any)[id] = false
            }
        } else if (value !== null) {
            ;(asset as any)[id] = null
        }
    })
}
